// src/utils/deepMerge.js

/**
 * Deeply merges two objects. Properties from source override those in target.
 * @param {Object} target - The target object (e.g., default styles).
 * @param {Object} source - The source object (e.g., merchant styles).
 * @returns {Object} - The merged object.
 */
export const DeepMerge = (target, source) => {
    const merged = { ...target };

    for (const key in source) {
        if (
            source[key] &&
            typeof source[key] === 'object' &&
            !Array.isArray(source[key])
        ) {
            merged[key] = DeepMerge(target[key] || {}, source[key]);
        } else {
            merged[key] = source[key];
        }
    }

    return merged;
};

export default DeepMerge;
